import { gettext } from '@eventbrite/i18n';
import { CreditCard } from '../assets/CreditCard';
import { GrowthEarth } from '../assets/GrowthEarth';
import { Spirituality } from '../assets/Spirituality';

export const COMMERCIAL_PROVEN_TITLE = gettext(
    'Unlock VIP Status with a Custom Plan 💪',
);
export const COMMERCIAL_PROVEN_DESCRIPTION = gettext(
    'Elevate your experience with a custom plan - think waived monthly fees, 24/7 support, and access to dedicated advisors. Our Sales team will reach out soon, or skip the wait and get in touch now.',
);
export const COMMERCIAL_UNPROVEN_TITLE = gettext(
    'Unlock VIP Status with a Custom Plan 🌟',
);
export const COMMERCIAL_UNPROVEN_DESCRIPTION = gettext(
    'Based on your ticket sales, you may be eligible for a custom plan. Think waived monthly fees, 24/7 support, and access to dedicated advisors.',
);
export const NEW_BUSINESS_TITLE = gettext('Join for the VIP treatment! 🌟');
export const NEW_BUSINESS_DESCRIPTION = gettext(
    'Based on your details, you may be eligible for a custom plan. Think waived publishing fees, priority support, and personalized onboarding.',
);

export const CTA_BUTTON_TEXT = gettext('Learn more');
export const DISMISS_BUTTON_TEXT = gettext('Not now');

export const MODAL_COMMERCIAL_PROVEN_TITLE = gettext(
    'Take advantage of exclusive savings and benefits!',
);
export const MODAL_COMMERCIAL_PROVEN_DESCRIPTION = gettext(
    'Based on your ticket sales, you could benefit from a custom plan. Share your information and our sales team will reach out soon.',
);

export const MODAL_COMMERCIAL_UNPROVEN_TITLE = gettext(
    'Take advantage of exclusive savings and benefits!',
);
export const MODAL_COMMERCIAL_UNPROVEN_DESCRIPTION = gettext(
    'Based on your ticket sales, you could benefit from a custom plan. Share your information and our sales team will reach out soon.',
);

export const MODAL_NEW_BUSINESS_TITLE = gettext(
    'You might be eligible for a custom plan!',
);
export const MODAL_NEW_BUSINESS_DESCRIPTION = gettext(
    '<span style="display: block; margin-bottom: 8px;">Based on your details, you’d be best suited for a custom plan.</span>Reach out to us directly at <span style="color: #F05537">+1 628-600-1786</span> to get started, or if you prefer, sign up to be contacted and  someone from our Sales team will be in touch shortly.',
);

export const MODAL_FORM_COMPLETE_TITLE = gettext('You’re all set!');
export const MODAL_FORM_COMPLETE_DESCRIPTION = gettext(
    'Your submission has been received and is being reviewed by our Sales team. Thanks for connecting with us!',
);
export const MODAL_FORM_COMPLETE_BUTTON_TEXT = gettext('Close');

export const MODAL_FEATURE_LEAD = gettext(
    'With a custom plan, you may be eligible to:',
);
export const MODAL_FEATURES = [
    {
        title: gettext('Save thousands on waived fees'),
        description: gettext(
            'Save on fees for all your events, big or small, so you can focus on what matters - growing your events.',
        ),
        icon: GrowthEarth,
    },
    {
        title: gettext('Scale your business—with support'),
        description: gettext(
            'From a personal strategic advisor, to 24/7 phone and email support, we’ve got you covered.',
        ),
        icon: Spirituality,
    },
    {
        title: gettext('Get paid easily, and earlier'),
        description: gettext(
            "Set up a fee structure that's right for your brand and gain access to more of your ticket revenue in advance.",
        ),
        icon: CreditCard,
    },
];

export const COUNTRY_PREFIX_LIST = [
    { label: 'ARG (+54)', value: 'AR' },
    { label: 'AUS (+61)', value: 'AU' },
    { label: 'BEL (+32)', value: 'BE' },
    { label: 'BRA (+55)', value: 'BR' },
    { label: 'CAN (+1)', value: 'CA' },
    { label: 'CHL (+56)', value: 'CL' },
    { label: 'COL (+57)', value: 'CO' },
    { label: 'DNK (+45)', value: 'DK' },
    { label: 'FIN (+358)', value: 'FI' },
    { label: 'DEU (+49)', value: 'DE' },
    { label: 'ESP (+34)', value: 'ES' },
    { label: 'FRA (+33)', value: 'FR' },
    { label: 'HKG (+852)', value: 'HK' },
    { label: 'IRL (+353)', value: 'IE' },
    { label: 'ITA (+39)', value: 'IT' },
    { label: 'MEX (+52)', value: 'MX' },
    { label: 'NLD (+31)', value: 'NL' },
    { label: 'NZL (+64)', value: 'NZ' },
    { label: 'AUT (+43)', value: 'AT' },
    { label: 'PER (+51)', value: 'PE' },
    { label: 'PRT (+351)', value: 'PT' },
    { label: 'SGP (+65)', value: 'SG' },
    { label: 'SWE (+46)', value: 'SE' },
    { label: 'CHE (+41)', value: 'CH' },
    { label: 'UK (+44)', value: 'GB' },
    { label: 'USA (+1)', value: 'US' },
];

export const COUNTRY_TO_PREFIX_MAPPING: Record<string, string> = {
    AR: '+54',
    AU: '+61',
    BE: '+32',
    BR: '+55',
    CA: '+1',
    CL: '+56',
    CO: '+57',
    DK: '+45',
    FI: '+358',
    DE: '+49',
    ES: '+34',
    FR: '+33',
    HK: '+852',
    IE: '+353',
    IT: '+39',
    MX: '+52',
    NL: '+31',
    NZ: '+64',
    AT: '+43',
    PE: '+51',
    PT: '+351',
    SG: '+65',
    SE: '+46',
    CH: '+41',
    GB: '+44',
    US: '+1',
};

export const ONBOARDING_ACTION = 'OnboardingAction';

export const ANSWERS_KEY = 'ob_answers';

export const SALES_OPTIONS_EVENT_VALUES = {
    ONE_EVENT: 88,
    TWO_TO_FIVE_EVENTS: 89,
    FIVE_TO_TEN_EVENTS: 90,
    TEN_TO_TWENTY_FIVE_EVENTS: 91,
    MORE_THAN_TWENTY_FIVE_EVENTS: 92,
    UNSURE: 93,
};

export const VISITOR_OPTIONS_COUNT_VALUES = {
    UP_TO_TWENTY_FIVE: 94,
    UP_TO_ONE_HUNDRED: 95,
    UP_TO_TWO_HUNDRED_AND_FIFTY: 96,
    MORE_THAN_TWO_HUNDRED_AND_FIFTY: 97,
    UNSURE: 98,
};
